<div [id]="id" [ngClass]="{ contentBorder: isOpen }">
  <div class="title-divider mt-1 row rubrik-divider">
    @if (isClosable) {
      <div class="buttonWrapper">
        <button
          (click)="toggle()"
          [ngClass]="{ open: isOpen, closed: !isOpen }"
          class="btn float-end mb-0 mt-0 py-0 openCloseButton"
          style="display: flex">
          <span class="mt-1">
            <i class="fas fa-angle-down" style="display: block"></i>
          </span>
          <ng-container *ngTemplateOutlet="titleSpan"></ng-container>
        </button>
      </div>
    } @else {
      <ng-container *ngTemplateOutlet="titleSpan"></ng-container>
    }

    @if (isOpen) {
      <div class="btn-group btn-group-sm buttonCol">
        <ng-content select="[titleActionButtons]"></ng-content>
      </div>
    }
  </div>

  @if (isOpen) {
    <div class="marginTop">
      <ng-content></ng-content>
    </div>
  }
</div>

<ng-template #titleSpan>
  <span [ngClass]="{ 'ms-2': isClosable }" class="mb-1 mt-0">
    <ng-content select="[title]"></ng-content>
  </span>
</ng-template>
